import HeaderMono from "../ui/HeaderMono";
import SkillCard from "../ui/SkillCard";
import { BrainIcon, CloudIcon, CodeIcon, DatabaseIcon, LibraryIcon, LineChartIcon } from "../../icons/Icons";
import { skills } from "../../content";

const ICONS = {
  brain: <BrainIcon className="w-4 h-4 text-emerald-300" />,
  cloud: <CloudIcon className="w-4 h-4 text-cyan-300" />,
  code: <CodeIcon className="w-4 h-4 text-emerald-300" />,
  line: <LineChartIcon className="w-4 h-4 text-cyan-300" />,
  database: <DatabaseIcon className="w-4 h-4 text-emerald-300" />,
  library: <LibraryIcon className="w-4 h-4 text-cyan-300" />,
};

export default function Skills({ sectionTint2 }) {
  return (
    <section id="skills" className={`border-t border-white/5 ${sectionTint2}`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <HeaderMono>Skills</HeaderMono>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {skills.map((g) => (
            <SkillCard key={g.title} title={g.title} icon={ICONS[g.icon]} items={g.items} />
          ))}
        </div>
      </div>
    </section>
  );
}
